import { useMutation, UseMutationOptions, useQuery } from "react-query";
import { fetchApi } from "@/helpers/reactQueryApi.ts";

export type Invite = {
  id: string;
  body: string;
  type: "ExternalInvite" | "MembershipInvite";
};

export function useInvite(inviteId: string) {
  return useQuery<Invite>(`/invites/${inviteId}`);
}

function renewUrl(inviteId: string, inviteType: string) {
  return inviteType === "ExternalInvite"
    ? `/external_invites/${inviteId}/renew`
    : `/membership_invites/${inviteId}/renew`;
}

export function useRenewInvite(
  inviteId: string,
  inviteType: string,
  options?: UseMutationOptions<unknown, Error, FormData>,
) {
  return useMutation<unknown, Error, FormData>(
    (body) =>
      fetchApi(renewUrl(inviteId, inviteType), {
        method: "POST",
        body,
      }),
    options,
  );
}

export function useBatchRenewInvites(
  options?: UseMutationOptions<
    unknown,
    Error,
    { body: string; invite_ids: string[] }
  >,
) {
  return useMutation<unknown, Error, { body: string; invite_ids: string[] }>(
    (data) =>
      fetchApi("/batch_invites/renew", {
        method: "POST",
        body: data,
      }),
    options,
  );
}
